import { useContext, useState } from 'react';
import { Button, ButtonToolbar } from 'reactstrap';
import { useParams } from 'react-router';
import { mapModes } from '../../constants/map';
import { MapContext } from '../../contexts/MapContext';
import DeletingToolbar from './DeletingToolbar';
import MaxWidthDiv from '../basics/MaxWidthDiv';
import ButtonWithShortcut from '../basics/ButtonWithShortcut';
import { SHORTCUTS } from '../../constants/shortcuts';
import { mutateAndDisplayErrors } from '../../utils/toast';

const SectionGroupToolbar = () => {
  const {
    sectionGroups: { removeSectionGroup },
    mapState: { setMapMode, activeSectionGroup },
  } = useContext(MapContext);
  const { farmId } = useParams();

  const [deleting, setDeleting] = useState(false);

  if (deleting) {
    return (
      <DeletingToolbar
        fullText="Are you sure you want to remove this grouping?"
        onCancel={() => {
          setDeleting(false);
        }}
        onConfirm={() => {
          mutateAndDisplayErrors(() =>
            removeSectionGroup(activeSectionGroup.id, farmId),
          );
          setMapMode(mapModes.VIEW);
        }}
      />
    );
  }

  return (
    <ButtonToolbar className="d-flex align-items-center">
      <MaxWidthDiv
        className="mr-2 font-weight-bold"
        title={activeSectionGroup.name}
      >
        {activeSectionGroup.name}
      </MaxWidthDiv>
      <Button
        onClick={() => setDeleting(true)}
        size="sm"
        outline
        className="mr-2"
      >
        Remove Grouping
      </Button>
      <ButtonWithShortcut
        shortcut={SHORTCUTS.CLOSE.key}
        onClick={() => setMapMode(mapModes.VIEW)}
        size="sm"
        color="primary"
      >
        Done
      </ButtonWithShortcut>
    </ButtonToolbar>
  );
};

export default SectionGroupToolbar;
